import type { VersionControlActionModalProps } from './version-control-modal.types';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { ModalLayout } from '../../../modal';
import { MinimalEditor } from '../../../tasks-tab/components/task-form/editor';
import { WarningBox } from '../warning-box';
import { StyledChangesInputWrapper, StyledMessage, StyledQuestionIcon } from './version-control-modal.styles';
export const VersionControlActionsModal = ({
  titleText,
  actionButtonText,
  message,
  warningBoxText,
  open,
  openChange,
  handleModalAction,
  closeButtonText = 'Cancel',
  changesTextInput = false,
  changesTextInputValue = '',
  changesTextInputOnChange
}: VersionControlActionModalProps) => <ModalLayout open={open} openChange={openChange} showTriggerElement={false} modalTitleText={titleText} customHeaderIcon={<StyledQuestionIcon icon={faQuestionCircle} />} closeButtonText={closeButtonText} actionButtonText={actionButtonText} actionButtonColor="primary" showWarnBox={false} handleActionButton={handleModalAction} data-sentry-element="ModalLayout" data-sentry-component="VersionControlActionsModal" data-sentry-source-file="version-control-modal.tsx">
    <StyledMessage data-sentry-element="StyledMessage" data-sentry-source-file="version-control-modal.tsx">{message}</StyledMessage>
    {warningBoxText && <WarningBox warningText={warningBoxText} />}

    {changesTextInput && changesTextInputOnChange && <StyledChangesInputWrapper>
        <MinimalEditor content={changesTextInputValue} onChange={changesTextInputOnChange} />
      </StyledChangesInputWrapper>}
  </ModalLayout>;